"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_spring_1 = require("react-spring");
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var color_1 = require("@seaweb/coral/utils/color");
var usePoppingQueue_1 = __importDefault(require("@seaweb/coral/hooks/usePoppingQueue"));
var useUnmountedEffect_1 = __importDefault(require("@seaweb/coral/hooks/useUnmountedEffect"));
var utils_1 = require("../ThemeProvider/utils");
var RippleRoot = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var Wave = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  will-change: box-shadow;\n\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  will-change: box-shadow;\n\n  ",
    "\n"])), function (_a) {
    var radius = _a.radius;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", ";\n  "], ["\n    border-radius: ", ";\n  "])), radius);
});
var AnimatedWave = react_spring_1.animated(Wave);
var Ripple = react_1.forwardRef(function (_a, ref) {
    var as = _a.as, _b = _a.colorType, colorType = _b === void 0 ? ThemeProvider_1.ColorTypes.Primary : _b, c = _a.color, r = _a.radius, _c = _a.intensity, intensity = _c === void 0 ? 0.15 : _c, props = __rest(_a, ["as", "colorType", "color", "radius", "intensity"]);
    var _d = usePoppingQueue_1.default(), queue = _d.queue, push = _d.push, stop = _d.stop;
    var ownRef = react_1.useRef(null);
    var createRipple = react_1.useCallback(function () { return push(true, 60); }, [push]);
    react_1.useImperativeHandle(ref, function () { return (__assign({ createRipple: createRipple }, ownRef.current)); });
    useUnmountedEffect_1.default(function () { return queue.forEach(function (_a) {
        var key = _a.key;
        return stop(key);
    }); });
    var transitions = react_spring_1.useTransition(queue, function (i) { return i.key; }, {
        from: { opacity: intensity - 0.05, spread: -2 },
        enter: { opacity: intensity, spread: 4 },
        leave: { opacity: 0, spread: 10 },
        config: { tension: 400, friction: 80 },
    });
    var color = utils_1.useColor(c, colorType);
    var radius = utils_1.useRadius(r);
    return (react_1.default.createElement(RippleRoot, __assign({ ref: ownRef, "aria-hidden": true }, props), transitions.map(function (_a) {
        var key = _a.key, s = _a.props;
        return (react_1.default.createElement(AnimatedWave, { key: key, radius: radius, style: {
                boxShadow: react_spring_1.interpolate([s.opacity, s.spread], function (o, sp) { return "0 0 0 " + sp + "px " + color_1.alp(color, o); }),
            } }));
    })));
});
exports.default = react_1.memo(Ripple);
var templateObject_1, templateObject_2, templateObject_3;
